<template>
    <div class="subwrap modulewrap">
        <div class="subbody realwrap" @click="showmorenav(false,false)">
            <div class="memnavwrap" v-if="!$store.getters.issmall">
                <div class="memface"><router-link to="/member/profile"><img :src="$common.getface($store.state.face)" /><br />{{$store.state.showname}}</router-link></div>
                <dl class="memnav">
                    <dd v-for="item in mynav" :key="item.id"><router-link :to="item.url" :class="{cs:(item.kv==curnavkv)}"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</router-link></dd>
                    <dd><a href="#" @click="$common.logout"><i class="iconfont icon-tuichudenglu"></i>{{$common.dicword('logout')}}</a></dd>
                </dl>
            </div>
            <div class="meminfo">
                <div class="memsubnav" v-if="!$store.getters.issmall">
                    <div class="navline"></div>
                    <dl v-if="$common.basic.isarrayexist(mynavsub)">
                        <dd v-for="item in mynavsub" :key="item.id"><a href="#" :class="{cs:navsub==item.kv}" @click="showsub(item.kv)">{{$common.langinfo(item.title,item.title_en)}}</a></dd>
                    </dl>
                    <dl v-else>
                        <dd><a href="#" class="cs">{{$common.langinfo(c_nav.title,c_nav.title_en)}}</a></dd>
                    </dl>
                </div>
                <div class="memsubnav" v-else>
                    <div class="navline"></div>

                    <div class="memnavbox">
                        <div class="memnavtop">

                            <a href="#" @click.stop.prevent="showmorenav(true)"><i :class="['iconfont',c_navmain.icon]"></i>{{$common.langinfo(c_navmain.title,c_navmain.title_en)}}</a>
                            <template v-if="$common.basic.isarrayexist(mynavsub)">
                                <i class="iconfont icon-fanye1"></i>
                                <a href="#" @click.stop.prevent="showmorenav(false,true)">{{$common.langinfo(c_navsub.title,c_navsub.title_en)}}</a>
                            </template>

                        </div>
                        <transition name="slidedown">
                            <div class="memmainnavmore" v-show="shownavmain">
                                <dl v-if="$common.basic.isarrayexist(mynav)">
                                    <dd v-for="item in mynav" :key="item.id">
                                        <router-link :to="item.url" :class="{cs:(item.kv==curnavkv)}"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</router-link>
                                    </dd>
                                </dl>
                            </div>
                        </transition>

                        <transition name="slidedown" v-if="$common.basic.isarrayexist(mynavsub)">
                            <div class="memsubnavmore" v-show="shownavsub">
                                <dl>
                                    <dd v-for="item in mynavsub" :key="item.id"><a href="#" :class="{cs:navsub==item.kv}" @click="showsub(item.kv)">{{$common.langinfo(item.title,item.title_en)}}</a></dd>
                                </dl>
                            </div>
                        </transition>
                    </div>
                </div>

                <div class="myoptions" v-if="c_options.hasoption">
                    <div class="myoptionleft">
                        <template v-if="c_options.showschool ||c_options.courselev>=0">

                            <template v-if="c_options.showschool">

                                <el-cascader ref="casgroup" v-model="casgroupvalue" v-if="c_showschool && c_showgroup" :options="optionlist.schoollist" size="mini" class="memselect" popper-class="calevel"
                                             :props="casoptiongroup" :show-all-levels="false" :placeholder="$common.dicword('allclass')" @change="groupchange"></el-cascader>

                                <el-select v-else-if="c_showschool" v-model="myoption.schoolid" size="mini" class="memselect" @change="selectcompany">
                                    <el-option v-for="item in optionlist.schoollist" :key="item.id" :label="$common.langinfo(item.title,item.title_en)" :value="item.id"></el-option>
                                </el-select>
                                <el-select v-else-if="c_showgroup" v-model="myoption.groupid" size="mini" class="memselect" @change="selectgroup">
                                    <el-option v-if="c_options.anygroup" :label="$common.dicword('allclass')" :value="-1"></el-option>
                                    <el-option v-for="item in optionlist.grouplist" :key="item.id" :label="$common.langinfo(item.title,item.title_en)" :value="item.id"></el-option>
                                </el-select>
                            </template>
                            <template v-if="c_options.courselev>0 && c_options.showcourse>0">
                                <template v-if="c_options.showcourse==1">
                                    <el-select v-model="myoption.levelid" size="mini" class="memselect" @change="selectlevel">
                                        <el-option :label="$common.dicword('alllevel')" :value="-1"></el-option>
                                        <el-option v-for="item in optionlist.levellist" :key="item.id" :label="$common.langinfo(item.title,item.title_en)" :value="item.id"></el-option>
                                    </el-select>
                                </template>
                                <template v-else>
                                    <el-cascader ref="caslevel" v-model="caslevelvalue" v-if="$common.basic.isarrayexist(c_levellist)" :options="c_levellist" size="mini" class="memselect" popper-class="calevel"
                                                 :props="casoption" :show-all-levels="false"
                                                 :clearable="c_options.anycourse" :placeholder="$common.dicword('allcourse')" @change="levelchange"></el-cascader>
                                </template>

                            </template>


                            <el-select v-if="c_options.hasstat && $common.basic.isobjexist(optionlist.statlist)" v-model="myoption.stat" size="mini" class="memselect" @change="optionchange()">
                                <el-option :label="$common.dicword('stat')" :value="-1"></el-option>
                                <el-option v-for="item in statlist" :key="item.kv" :label="$common.langinfo(item.title,item.title_en)" :value="item.kv"></el-option>
                            </el-select>
                        </template>
                    </div>
                    <div class="myoptionright" v-if="c_options.haskw&&!$store.getters.issmall">
                        <el-input :placeholder="$common.dicword('keyword')" size="mini" suffix-icon="el-icon-search" class="memsearch" v-model="myoption.kw" @change="optionchange()" @keyup.enter.native="optionchange()"></el-input>
                    </div>
                </div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Cmember',
        data() {
            return {
                me: {},
                mynav: [],
                mynavsub: [],
                myoption: {
                    schoolid: -1,
                    groupid: -1,
                    levelid: -1,
                    courseid: -1,
                    realid: -1,
                    topicid: -1,
                    lessonid: -1,
                    stat: -1,
                    kw: '',
                    k: -1,
                },
                optionlist: {
                    levellist: [],
                    courselist: [],
                    topiclist: [],
                    lessonlist: [],
                    schoollist: [],
                    grouplist: [],
                    statlist: [],
                    schlist: []
                },
                casgroupvalue: '',
                caslevelvalue: '',
                shownavmain: false,
                shownavsub: false
            };
        },
        props: {
            curnavkv: {
                type: Number,
                default: 0
            },
            navsub: {
                type: Number,
                default: 0
            },
            options: {
                type: Object,
                default: () => { }
            }
        },
        computed: {
            c_nav: function () {
                return this.$common.basic.fffind(this.mynav, 'kv', this.curnavkv);
            },
            c_options: function () {
                let dfoptions = {
                    'anycourse': true, 'courselev': 0, 'hasoption': false, 'hasstat': 0, 'haskw': false, 'anygroup': true, 'noteng': 0, 'hasgroup': 0, 'showschool': false, 'showgroup': false, 'anyschool': false, 'showcourse': 0, 'issch': 0, 'schstat': 0
                };
                return Object.assign({}, dfoptions, this.options);
            },
            c_navmain: function () {
                return this.$common.basic.fffind(this.mynav, 'kv', this.curnavkv);
            },
            c_navsub: function () {
                return this.$common.basic.fffind(this.mynavsub, 'kv', this.navsub);
            },
            c_showschool: function () {

                return this.c_options.showschool && this.optionlist.schoollist.length > 1;
            },
            c_showgroup: function () {

                return this.c_options.showgroup && this.optionlist.grouplist.length > 0;
            },
            casoptiongroup: function () {
                return this.c_options.anygroup ? { checkStrictly: true, expandTrigger: 'hover', value: 'id', label: 'title', children: 'x_children' } : { expandTrigger: 'hover', value: 'id', label: 'title', children: 'x_children' };
            },
            casoption: function () {
                return this.c_options.anycourse ? { checkStrictly: true, expandTrigger: 'hover', value: 'id', label: 'title', children: 'x_children' } : { expandTrigger: 'hover', value: 'id', label: 'title', children: 'x_children' };
            },
            c_levellist: function () {
                let _levellist = this.$common.basic.jsonclone(this.optionlist.levellist);
                let _courselist = this.$common.basic.jsonclone(this.optionlist.courselist);
                let _topiclist = this.$common.basic.jsonclone(this.optionlist.topiclist);
                let _lessonlist = this.$common.basic.jsonclone(this.optionlist.lessonlist);

                if (this.c_options.showcourse > 3) {
                    this.$common.each(_topiclist, item => {
                        item.x_children = this.$common.basic.fffilter(_lessonlist, "pid", item.id);
                    });
                }
                if (this.c_options.showcourse > 2) {
                    this.$common.each(_courselist, item => {
                        item.x_children = this.$common.basic.fffilter(_topiclist, "pid", item.id);
                    });
                }
                if (this.c_options.showcourse > 1) {
                    this.$common.each(_levellist, item => {
                        item.x_schstat = 0;

                        if (this.c_options.schstat == 1) {
                            item.x_children = this.$common.basic.fffilter2(_courselist, "levelid", item.id, 'x_schstat', 1);
                            if (this.$common.basic.isarrayexist(item.x_children)) {
                                item.x_schstat = 1;
                            }
                        }
                        else if (this.c_options.schstat == 2) {
                            item.x_children = this.$common.basic.fffilter2(_courselist, "levelid", item.id, 'x_schstat', 2);
                            if (this.$common.basic.isarrayexist(item.x_children)) {
                                item.x_schstat = 2;
                            }
                        }
                        else if (this.c_options.schstat == 3) {
                            item.x_children = this.$common.basic.fffilter2(_courselist, "levelid", item.id, 'x_schstat', 0);
                            if (this.$common.basic.isarrayexist(item.x_children)) {
                                item.x_schstat = 0;
                            }
                        }
                        else {
                            item.x_children = this.$common.basic.fffilter(_courselist, "levelid", item.id);
                        }

                    });
                }

                if (this.c_options.schstat == 1) {
                    _levellist = this.$common.basic.fffilter(_levellist, 'x_schstat', 1);
                }
                else if (this.c_options.schstat == 2) {
                    _levellist = this.$common.basic.fffilter(_levellist, 'x_schstat', 2);
                }
                else if (this.c_options.schstat == 3) {
                    _levellist = this.$common.basic.fffilter(_levellist, 'x_schstat', 0);
                }

                return _levellist;
            }
        },
        methods: {
            showsub: function (v, isforce = false) {

                this.showmorenav();
                isforce = isforce || (v != this.navsub);

                if (isforce) {
                    this.$emit('update:navsub', v);

                    this.$nextTick(function () {

                        let nlevelid = -1;
                        let ncourseid = -1;
                        let ntopicid = -1;
                        let nlessonid = -1;
                        if (this.myoption.levelid > 0) {
                            let levelitem = this.$common.basic.fffind(this.c_levellist, 'id', this.myoption.levelid);
                            if (this.$common.basic.isobjexist(levelitem)) {
                                nlevelid = levelitem.id;
                                if (this.myoption.courseid > 0) {
                                    let courseitem = this.$common.basic.fffind(levelitem.x_children, 'id', this.myoption.courseid);
                                    if (this.$common.basic.isobjexist(courseitem)) {
                                        ncourseid = courseitem.id;
                                        if (this.myoption.topicid > 0) {
                                            let topicitem = this.$common.basic.fffind(courseitem.x_children, 'id', this.myoption.topicid);
                                            if (this.$common.basic.isobjexist(topicitem)) {
                                                ntopicid = topicitem.id;
                                            }
                                            if (this.myoption.lessonid > 0) {
                                                let lessonitem = this.$common.basic.fffind(topicitem.x_children, 'id', this.myoption.lessonid);
                                                if (this.$common.basic.isobjexist(lessonitem)) {
                                                    nlessonid = lessonitem.id;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }


                        if (!this.c_options.anycourse) {
                            if (ncourseid <= 0) {
                                nlevelid = this.$common.basic.isarrayexist(this.c_levellist) ? this.c_levellist[0].id || 0 : 0;
                                ncourseid = nlevelid ? this.$common.basic.isarrayexist(this.c_levellist[0].x_children) ? this.c_levellist[0].x_children[0].id || 0 : 0 : 0;
                                this.caslevelvalue = [nlevelid, ncourseid];

                            }
                        }
                        this.clearoptions(nlevelid, ncourseid, ntopicid, nlessonid);

                        this.optionchange();
                    });
                }

            },
            getdata: function () {
                let jsondata = {
                    'postdata': {
                        'api': 'member', 'act': 'membernavtc', 'data': {
                            'kv': this.curnavkv, 'hasgroup': this.c_options.hasgroup
                        }
                    }, 'msg': ''
                };
                this.$common.post(jsondata, res => {
                    this.me = res.infodatame;
                    this.mynav = res.infodatamemnav;
                    if (this.$common.basic.isarrayexist(res.infodatamemnavsub)) {
                        this.mynavsub = res.infodatamemnavsub;
                    }
                    //this.$store.dispatch('setmemlev', this.me.lev);//在登录和header里设置
                    if (this.c_options.hasgroup) {
                        this.$common.each(res.infodataschool, item => {
                            item.x_children = this.$common.basic.fffilter(res.infodatagroup, "companyid", item.id);
                        });
                        this.optionlist.schoollist = res.infodataschool;
                        this.optionlist.grouplist = res.infodatagroup;

                        if (!this.c_options.anyschool) {
                            if (this.$common.basic.isarrayexist(this.optionlist.schoollist)) {
                                if (this.myoption.schoolid <= 0) {
                                    this.myoption.schoolid = this.optionlist.schoollist[0].id;

                                    if (!this.c_options.anygroup) {
                                        this.myoption.groupid = this.optionlist.schoollist[0].x_children[0].id;
                                    }
                                }
                                this.casgroupvalue = [this.myoption.schoolid];
                                if (this.myoption.groupid > 0) {
                                    this.casgroupvalue.push(this.myoption.groupid);
                                }
                            }
                        }

                        this.$emit('groupupdate', res.infodatagroup);
                        //this.$emit('setgroup', { 'schoollist': res.infodataschool, 'grouplist': res.infodatagroup });
                    }

                    if (this.c_options.anycourse) {
                        this.showsub(this.navsub, true);
                    }

                    this.getoptions();

                });
            },
            optionchange: function () {
                this.myoption.realid = 0;
                if (this.myoption.courseid > 0) {
                    let course = this.$common.basic.fffind(this.optionlist.courselist, 'id', this.myoption.courseid);
                    if (this.$common.basic.isobjexist(course)) {
                        this.myoption.realid = course.realid;
                    }
                }
                this.$emit('optionchange', this.myoption);
            },
            getoptions: function () {
                if (this.c_options.hasoption && this.c_options.courselev > 0) {
                    let jsondata = {
                        'postdata': { 'act': 'tc_mem_options', 'data': { 'courselev': this.c_options.courselev, 'noteng': this.c_options.noteng, 'hasstat': this.c_options.hasstat, 'issch': this.c_options.issch } }, 'msg': ''
                    };
                    this.$common.post(jsondata, res => {

                        this.$common.each(res.infodatacourse, item => {
                            let schitem = this.$common.basic.fffind(res.infodatasch, 'courseid', item.id);
                            if (this.$common.basic.isobjexist(schitem)) {
                                item.x_stat = schitem.stat || 0;
                                item.x_schstat = schitem.stat == 9 ? 2 : 1;
                            }
                            else {
                                item.x_stat = 0;
                                item.x_schstat = 0;
                            }
                        });

                        this.optionlist.levellist = res.infodata || [];
                        this.optionlist.courselist = res.infodatacourse || [];
                        this.optionlist.topiclist = res.infodatatopic || [];
                        this.optionlist.lessonlist = res.infodatalesson || [];
                        this.optionlist.schlist = res.infodatasch || [];

                        this.optionlist.statlist = res.infodatastat;

                        if (!this.c_options.anycourse) {

                            let firstlevelid = this.$common.basic.isarrayexist(this.c_levellist) ? this.c_levellist[0].id || 0 : 0;
                            let firstcourseid = firstlevelid ? this.$common.basic.isarrayexist(this.c_levellist[0].x_children) ? this.c_levellist[0].x_children[0].id || 0 : 0 : 0;
                            this.caslevelvalue = [firstlevelid, firstcourseid];
                            this.clearoptions(firstlevelid, firstcourseid);

                            this.optionchange();
                        }
                    });
                }
            },

            clearoptions: function (levelid = 0, courseid = 0, topicid = 0, lessonid = 0) {
                this.myoption.lessonid = lessonid > 0 ? lessonid : -1;
                this.myoption.topicid = topicid > 0 ? topicid : -1;
                this.myoption.courseid = courseid > 0 ? courseid : -1;
                this.myoption.levelid = levelid > 0 ? levelid : -1;

                /*if (lessonid > 0) {
                    this.myoption.lessonid = lessonid;
                }
                else {
                    this.myoption.lessonid = -1;
                    if (topicid > 0) {
                        this.myoption.topicid = topicid;
                    }
                    else {
                        this.myoption.topicid = -1;
                        if (courseid > 0) {
                            this.myoption.courseid = courseid;
                        }
                        else {
                            this.myoption.courseid = -1;
                            if (levelid > 0) {
                                this.myoption.levelid = levelid;
                            }
                            else {
                                this.myoption.levelid = -1;
                            }
                        }
                    }
                }*/
            },
            selectlevel: function (v) {
                this.clearoptions(v);
                this.optionchange();
            },
            levelchange: function (e) {
                this.$refs.caslevel.dropDownVisible = false;
                if (this.$common.basic.isarrayexist(e)) {
                    this.clearoptions(e[0], e.length > 1 ? e[1] : -1, e.length > 2 ? e[2] : - 1, e.length > 3 ? e[3] : - 1);
                }
                else {
                    this.clearoptions();
                }
                this.optionchange();
            },
            selectcompany: function () {
                this.myoption.groupid = -1;
                this.optionchange();
            },
            selectgroup: function () {
                this.optionchange();
            },
            groupchange: function (e) {
                this.$refs.casgroup.dropDownVisible = false;
                if (this.$common.basic.isarrayexist(e)) {
                    this.myoption.schoolid = e[0];
                    this.myoption.groupid = e.length > 1 ? e[1] : -1;

                }
                else {
                    this.myoption.schoolid = -1;
                    this.myoption.groupid = -1;
                }
                this.optionchange();
            },
            showmorenav: function (m = false, s = false) {
                this.shownavmain = m ? !this.shownavmain : false;
                this.shownavsub = s ? !this.shownavsub : false;
            }
        },
        mounted() {
            this.getdata();
        }
    }

</script>
